import { parseUrl } from 'hub-http/helpers/url';
import { getFullUrl } from 'hubspot-url-utils';
import { na1 } from 'hubspot-url-utils/hublets';
import { getLocalizedHubSpotUrl, getPublicLocalizedPathname } from 'marketplace-ui-common/utils/urls';
import PortalIdParser from 'PortalIdParser';
const validLegalLangs = ['ja', 'de', 'en', 'es', 'pt', 'pt-br', 'fr'];
const getExternalLocalizedPath = (lang = 'en') => {
  switch (lang) {
    case 'ja':
      return '/jp';
    case 'pt':
    case 'pt-br':
      return '/br';
    case 'de':
    case 'es':
    case 'fr':
      return `/${lang}`;
    default:
      return '';
  }
};
export const getFormattedUrl = href => {
  if (!href) return undefined;
  const {
    protocol
  } = parseUrl(href);
  return !protocol ? `http://${href}` : href;
};
export const getHubSpotPricingUrl = (lang = 'en') => {
  return `${getLocalizedHubSpotUrl(lang)}/pricing`;
};
export const getHubSpotAiProductsTermsUrl = (lang = 'en') => {
  const legalLang = validLegalLangs.includes(lang) ? lang : 'en';
  return `https://legal.hubspot.com${getExternalLocalizedPath(legalLang)}/product-specific-terms#AI-prod`;
};
export const getHubSpotBetaTermsUrl = (lang = 'en') => {
  const legalLang = validLegalLangs.includes(lang) ? lang : 'en';
  return `https://legal.hubspot.com${getExternalLocalizedPath(legalLang)}/hubspot-beta-terms`;
};
export const getHubSpotPrivacyUrl = (lang = 'en') => {
  const legalLang = validLegalLangs.includes(lang) ? lang : 'en';
  return `https://legal.hubspot.com${getExternalLocalizedPath(legalLang)}/privacy-policy`;
};
export const getHubSpotTermsOfServiceUrl = (lang = 'en') => {
  const legalLang = validLegalLangs.includes(lang) ? lang : 'en';
  return `https://legal.hubspot.com${getExternalLocalizedPath(legalLang)}/terms-of-service`;
};
export const getHubSpotAcceptableUseUrl = (lang = 'en') => {
  const legalLang = validLegalLangs.includes(lang) ? lang : 'en';
  return `https://legal.hubspot.com${getExternalLocalizedPath(legalLang)}/acceptable-use`;
};
export const getCategoryUrl = ({
  appContext,
  category,
  productType
}) => {
  const baseUrl = getFullUrl(appContext === 'app' ? 'app' : 'ecosystem', {
    hubletOverride: na1
  });
  if (appContext === 'app') {
    return `${baseUrl}/marketplace/${PortalIdParser.get()}/explore?eco_PRODUCT_TYPE=${productType}&eco_CATEGORY=${category}`;
  }
  return `${baseUrl}/marketplace/explore?eco_PRODUCT_TYPE=${productType}&eco_CATEGORY=${category}`;
};
export function getBreezeStudioUrl(agentType) {
  return `${getFullUrl('app')}/breeze-studio/${PortalIdParser.get()}/manage-agents/${agentType === 'ASSISTANT' ? 'assistants' : 'agents'}`;
}
export function getAgentStudioUrl(instanceId) {
  return `${getFullUrl('app')}/breeze-studio/${PortalIdParser.get()}/run-agent/${instanceId}`;
}
export function getAgentStudioConfigurationUrl(instanceId, agentType) {
  return `${getFullUrl('app')}/breeze-studio/${PortalIdParser.get()}/agent-builder/${agentType === 'ASSISTANT' ? 'assistants' : 'automated-agents'}/${instanceId}/edit`;
}
export const getDataSyncProductUrl = (lang = 'en') => `${getLocalizedHubSpotUrl(lang)}/products/data-sync`;
export const getRootUrl = appContext => {
  return `/marketplace${appContext === 'app' ? `/${PortalIdParser.get()}` : ''}`;
};
export function getConnectedAppsUrl() {
  const base = getFullUrl('app');
  return `${base}/integrations-settings/${PortalIdParser.get()}/installed`;
}
export function getInstalledAppOverviewUrl(appId) {
  return `${getConnectedAppsUrl()}/basic/${appId}/overview`;
}

//util used to handle embedded (iframe) vs. non-embedded routing
export function navigateTo(url, isEmbedded) {
  if (isEmbedded) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
}

// shortlinks will always take you to the in-app details page
export function getAppDetailsShortlink(slug) {
  return `${getFullUrl('app')}/l/marketplace/listing/${slug}`;
}
export function getPublicAppDetailsUrl(slug) {
  return `${getFullUrl('ecosystem')}/marketplace/listing/${slug}`;
}
export function getPublicLocalizedListingDetailsUrl(slug, language) {
  const languagePrefix = getPublicLocalizedPathname(language);
  return `${getFullUrl('ecosystem')}${languagePrefix}/marketplace/listing/${slug}`;
}
export function getAppDetailsUrl(appContext, slug) {
  return appContext === 'app' ? getAppDetailsShortlink(slug) : getPublicAppDetailsUrl(slug);
}
export function getAppFeatureDiscoveryUrl(appId, portalId) {
  return `${getFullUrl('app')}/integrations-settings/${portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get()}/installed/application/${appId}/featureDiscovery`;
}
export function getAppOverviewUrl(appId, portalId) {
  return `${getFullUrl('app')}/integrations-settings/${portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get()}/installed/application/${appId}/overview`;
}
export function getAppAppCardsUrl(appId, portalId) {
  return `${getFullUrl('app')}/integrations-settings/${portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get()}/installed/application/${appId}/app-cards`;
}